import { AppLayout } from 'layouts';
import { useParams } from 'react-router';
import { ChannelsGivings } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToGivings } from '../hooks';

const PageChannelsGivings = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToGivings = useNavigateToGivings();

  return (
    <AppLayout>
      <ChannelsGivings
        getPathToGivingDetail={(id) => getPathToEntityDetail(id, { entityType: 'giving' })}
        navigateToGivings={navigateToGivings}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Todo fix this
        organizationId={organizationId!}
      />
    </AppLayout>
  );
};

export default PageChannelsGivings;
